import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BloqueoModulo } from 'src/app/shared/object/bloqueo-vista.Interface';
import { BloqueoModuloService } from 'src/app/shared/services/bloqueo-modulo.service';

@Component({
  selector: 'bloqueo-vista-errors',
  templateUrl: './bloqueo-vista-errors.component.html',
  styleUrls: ['./bloqueo-vista-errors.component.scss']
})
export class BloqueoVistaErrorsComponent implements OnInit {
  bloqueo?: BloqueoModulo;
  message?: string;

  constructor(
    private router: Router,
    private bloqueoVistaService: BloqueoModuloService,
  ) { }

  get messageValue(): string {
    const mensajeDefault = 'No fue posible adquirir el bloqueo del módulo.';
    return this.bloqueo ? this.bloqueo.mensajeError || mensajeDefault : this.message || mensajeDefault;
  }

  ngOnInit() {
    const navigation = this.router.getCurrentNavigation();
    if (!navigation || !navigation.extras || !navigation.extras.state) {
      this.bloqueo = this.bloqueoVistaService.bloqueoActualValue;
      return;
    }

    const bloqueoDesdeEstado = navigation.extras.state['bloqueo'] as BloqueoModulo | undefined;
  
    this.bloqueo = bloqueoDesdeEstado || this.bloqueoVistaService.bloqueoActualValue;
  
    if (!this.bloqueo || !this.bloqueo.mensajeError) {
      this.message = 'No fue posible determinar el motivo exacto del bloqueo.';
    }
  }

  regresar() {
    this.router.navigate(['']);
  }
}
